import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';

import { Logger } from '../logger';

const log = new Logger('WelcomeEmailService');

@Injectable({
  providedIn: 'root'
})
export class WelcomeEmailService {
  constructor(private http: HttpClient) {}

  /** The API claims the send once per account, so repeat calls never deliver a duplicate. */
  send(): Observable<boolean> {
    return this.http.post('/account/welcome-email', null, { observe: 'response' }).pipe(
      map(response => {
        log.debug(`Welcome email request completed with status ${response.status}`);

        return true;
      }),
      catchError(error => {
        // Warn, not debug: production logs at Warning, and the API schedules no retry.
        log.warn('Welcome email request failed', { status: error?.status });

        return of(false);
      })
    );
  }
}
